"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.controls.knowledgePicker.label': 'Select Knowledge',
    'ai.controls.knowledgePicker.show': 'Use Knowledge Base',
};
